import { openPopupBus } from "../../../components/MessageBus";
import router from "@/router";
import store from "@/store"; // Make sure to import your store

const loadComponent = (name) => {
  store.dispatch("startLoading");
  if (!modules[name]) {
    store.dispatch("endLoading");
    return Promise.reject(new Error(`Componente ${name} não encontrado.`));
  }
  return modules[name]()
    .then((component) => {
      store.dispatch("endLoading");
      return component;
    })
    .catch((error) => {
      store.dispatch("endLoading");
      throw error;
    });
};

const modules = {
  Viability: () => import("./ViabilityMap"),
  Image: () => import("./Image"),
  ImageUpload: () => import("./ImageUpload"),
  Comment: () => import("./Comment"),
  CommentInput: () => import("./CommentInput"),
  MessageList: () => import("./MessageList"),
  PrintMap: () => import("./PrintMap"),
  FolderList: () => import("./FolderList"),
  FolderInput: () => import("./FolderInput"),
  FolderReport: () => import("./FolderReport"),
  FolderUserList: () => import("./FolderUserList"),
  FolderChange: () => import("./FolderChange"),
  CableClient: () => import("./CableClient"),
  SplitterOrganizerInput: () => import("./SplitterOrganizerInput"),
  FolderChangeMap: () => import("./FolderChangeMap"),
  CtoChange: () => import("./CtoChange"),
  CeoChange: () => import("./CeoChange"),
  OtdrModule: () => import("./OtdrModule"),
  ClientWithoutConnection: () => import("./ClientWithoutConnection"),
  Deactivation: () => import("./Deactivation"),
  ConnectionOrganizer: () => import("./ConnectionOrganizer"),
  ConnectionLabelChange: () => import("./ConnectionLabelChange"),
  UsersFolder: () => import("./UsersFolder"),
  ClientWithoutOltAssociation: () => import("./ClientWithoutOltAssociation"),
  KmlUpload: () => import("../../importer/KmlUpload"),
  KmlExtractList: () => import("../../importer/KmlExtractList"),
  ConnectionReport: () => import("./ConnectionReport"),
  Layers: () => import("./Layers"),
  DioInput: () => import("./DioInput"),
  SplitterInput: () => import("./SplitterInput"),
  SwitchInput: () => import("./SwitchInput"),
  ContactInput: () => import("./ContactInput"),
  BlockInput: () => import("./BlockInput"),
  OltInput: () => import("./OltInput"),
  StreetView: () => import("./StreetView"),
  Conexao: () => import("./Conexao"),
  Diagram: () => import("./Diagram"),
  DamagedFiber: () => import("./DamagedFiber"),
  DamagedFiberList: () => import("./DamagedFiberList"),
  OltBoardInput: () => import("./OltBoardInput"),
  EquipmentLimit: () => import("./EquipmentLimit"),
  Building: () => import("./Building"),
  HardwareKitChange: () => import("./HardwareKitChange.vue"),
  TipScreen: () => import("../../info/TipScreen.vue"),
};

// Create wrapped versions of the lazy-loaded components
const Viability = () => loadComponent("Viability");
const Image = () => loadComponent("Image");
const ImageUpload = () => loadComponent("ImageUpload");
const Comment = () => loadComponent("Comment");
const CommentInput = () => loadComponent("CommentInput");
const MessageList = () => loadComponent("MessageList");
const PrintMap = () => loadComponent("PrintMap");
const FolderList = () => loadComponent("FolderList");
const FolderInput = () => loadComponent("FolderInput");
const FolderReport = () => loadComponent("FolderReport");
const FolderUserList = () => loadComponent("FolderUserList");
const FolderChange = () => loadComponent("FolderChange");
const CableClient = () => loadComponent("CableClient");
const SplitterOrganizerInput = () => loadComponent("SplitterOrganizerInput");
const FolderChangeMap = () => loadComponent("FolderChangeMap");
const CtoChange = () => loadComponent("CtoChange");
const CeoChange = () => loadComponent("CeoChange");
const OtdrModule = () => loadComponent("OtdrModule");
const ClientWithoutConnection = () => loadComponent("ClientWithoutConnection");
const Deactivation = () => loadComponent("Deactivation");
const ConnectionOrganizer = () => loadComponent("ConnectionOrganizer");
const ConnectionLabelChange = () => loadComponent("ConnectionLabelChange");
const UsersFolder = () => loadComponent("UsersFolder");
const ClientWithoutOltAssociation = () => loadComponent("ClientWithoutOltAssociation");
const KmlUpload = () => loadComponent("KmlUpload");
const KmlExtractList = () => loadComponent("KmlExtractList");
const ConnectionReport = () => loadComponent("ConnectionReport");
const Layers = () => loadComponent("Layers");
const DioInput = () => loadComponent("DioInput");
const SplitterInput = () => loadComponent("SplitterInput");
const SwitchInput = () => loadComponent("SwitchInput");
const ContactInput = () => loadComponent("ContactInput");
const BlockInput = () => loadComponent("BlockInput");
const OltInput = () => loadComponent("OltInput");
const StreetView = () => loadComponent("StreetView");
const Conexao = () => loadComponent("Conexao");
const Diagram = () => loadComponent("Diagram");
const DamagedFiber = () => loadComponent("DamagedFiber");
const DamagedFiberList = () => loadComponent("DamagedFiberList");
const OltBoardInput = () => loadComponent("OltBoardInput");
const EquipmentLimit = () => loadComponent("EquipmentLimit");
const Building = () => loadComponent("Building");
const HardwareKitChange = () => loadComponent("HardwareKitChange");
const TipScreen = () => loadComponent("TipScreen");

import Pop from "./Pop";
import Amendment from "./Amendment";
import Client from "./Client";
import Cto from "./Cto";
import Cable from "./Cable";
import Pole from "./Pole";
import Polygon from "./Polygon";
import TechnicalReserve from "./TechnicalReserve";
import CommentMap from "./CommentMap";
import MultiSelect from "./MultiSelect";
import VirtualCircuit from "./VirtualCircuit";
import Cordoalha from "./Cordoalha";
import MaintenancePoint from "./MaintenancePoint";
import VerticalCondominium from "./VerticalCondominium";



const isMobile = window.orientation > -1;

const openPopup = (component, options = {}) => {
  // Extrair propriedades do objeto de opções
  const {
    id = null,
    geometry = null,
    listItens = null,
    equipmentId = null,
    entity = null,
    heightFull = null,
    isProject = null,
    extra = null,
    folderIdMap = null,
    leftMenu = null,
    middle = null,
    cb = null,
    right = null,
    left = null,
    keepOpen = false
  } = options;
  
  let componentId = Math.random();
  let varFullScreen = false;

  if (isMobile || heightFull) {
    varFullScreen = true;
  }

  openPopupBus({
    component: component,
    props: {
      id,
      geometry,
      listItens,
      equipmentId,
      entity,
      isProject,
      fullScreen: varFullScreen,
      middle,
      componentId,
      extra,
      folderIdMap,
      leftMenu,
      featureType: entity && entity.type ? entity.type : null,
      cb,
      right,
      left,
      keepOpen
    },
  });
};

export const openPopupLayer = (layerList) => {
  openPopup(Layers, {
    listItens: layerList,
    equipmentId: true,
    left: true
  });
};

export const openMultiSelect = (layerList, isMove) => {
  openPopup(MultiSelect, {
    listItens: layerList,
    equipmentId: true,
    extra: isMove
  });
};

export const openPopupDamaged = () => {
  openPopup(DamagedFiberList, {
    equipmentId: true
  });
};

export const openPopupMessage = () => {
  openPopup(MessageList, {
    equipmentId: true,
    heightFull: true
  });
};

export const openPrintMap = () => {
  openPopup(PrintMap, {});
};

export const openPopupFolder = () => {
  openPopup(FolderList, {
    equipmentId: true,
    right: true
  });
};

export const openPopupUsersFolder = (id) => {
  openPopup(UsersFolder, {
    id: id
  });
};

export const openPopupClientWithoutConnection = () => {
  openPopup(ClientWithoutConnection, {
    right: true
  });
};

export const openPopupDeactivation = () => {
  openPopup(Deactivation, {
    heightFull: true
  });
};

export const openPopupClientWithoutOltAssociation = () => {
  openPopup(ClientWithoutOltAssociation, {});
};

export const openPopupTipScreen = (page) => {
  openPopup(TipScreen, {
    entity: page,
    middle: true
  });
};

export const openPopupOltInput = (id, equipmentId, cb) => {
  openPopup(OltInput, {
    id,
    equipmentId,
    cb
  });
};

export const openKmlInput = (geometry) => {
  router.push({
    name: "kmlExtract",
    params: { geometry: geometry },
  });
};

// export const openPopupImporter = () => {
//     openPopup(Importer, null, null, null, null, null, true)
// }

export const openSubPopup = (
  popup,
  entityId,
  equipmentId,
  entity,
  projectId,
  extra,
  folderIdMap,
  url,
  cb
) => {
  let component;

  let heightFull = false;
  let middle = false;
  let keepOpen = false;
  // console.log('openSUBPopup EXTRA', entityId, extra)

  switch (popup) {
    case 1:
      component = DioInput;
      break;
    case 2:
      component = SplitterInput;
      break;
    case 3:
      component = Conexao;
      // width = true
      heightFull = true;

      break;
    case 4:
      component = Diagram;
      // width = true
      //used to identify if the diagram is resumed
      entityId = true;
      heightFull = true;
      break;
    case 5:
      component = Diagram;
      // width = true
      heightFull = true;
      break;
    case 6:
      component = Viability;
      middle = true;
      break;
    case 7:
      component = ConnectionReport;
      break;
    case 8:
      component = Image;
      break;
    case 9:
      component = ImageUpload;
      break;
    /*case 10: removido utilizando uma nova lib que faz o papael de exibir as imagens
            component = ImageFull
            break*/
    case 11:
      component = Comment;
      break;
    case 12:
      component = CommentInput;
      break;
    // case 13:
    //     component = ProjectInput
    //     break
    // case 14:
    //     component = ProjectReport
    //     break
    case 15:
      component = OltInput;
      break;
    // case 16:
    //     component = DoorReserve
    //     break
    case 17:
      component = DamagedFiber;
      break;
    // case 18:
    //   component = FolderCapexReport
    //   break
    case 19:
      component = OltBoardInput;
      break;
    case 20:
      component = FolderInput;
      break;
    case 21:
      component = FolderReport;
      middle = true;
      break;
    case 23:
      component = FolderUserList;
      break;
    case 24:
      component = FolderChange;
      break;
    case 25:
      component = CableClient;
      break;
    case 26:
      component = SplitterOrganizerInput;
      break;
    case 27:
      component = CtoChange;
      break;
    case 28:
      component = OtdrModule;
      break;
    case 29:
      component = Building;
      heightFull = true;
      keepOpen = true;
      break;
    case 30:
      component = ConnectionOrganizer;
      break;
    case 31:
      component = ConnectionLabelChange;
      break;
    // case 32:
    //   component = Movie;
    //   break;
    case 33:
      component = KmlUpload;
      break;
    case 34:
      component = SwitchInput;
      break;
    case 35:
      component = ContactInput;
      break;
    case 36:
      component = BlockInput;
      break;
    case 37:
      component = KmlExtractList;
      break;
    case 38:
      component = CeoChange;
      break;
    case 39:
      component = HardwareKitChange;
      break;
  }

  if (component) {
    openPopup(component, {
      id: entityId,
      equipmentId,
      entity,
      heightFull,
      isProject: projectId,
      extra,
      folderIdMap,
      leftMenu: url,
      middle,
      cb,
      keepOpen
    });
  }
};

export const openPopupMap = (entity, geometry, isProject, extra) => {
  let component;

  switch (entity.type) {
    case "P":
      component = Pop;
      break;

    case "C":
      component = Amendment;
      break;

    case "S":
      component = Client;
      break;

    case "O":
      component = Cto;
      break;

    case "CD":
    case "CC":
      component = Cable;
      break;
    case "U":
      component = Polygon;
      break;
    case "T":
      component = TechnicalReserve;
      break;
    case "E":
      component = Pole;
      break;
    case "G":
      component = StreetView;
      break;
    case "SP":
      component = CommentMap;
      break;
    case "CV":
      component = VirtualCircuit;
      break;
    case "CL":
      component = Cordoalha;
      break;
    case "MP":
      component = MaintenancePoint;
      break;
    case "MV":
      component = FolderChangeMap;
      break;
    case "V":
      component = VerticalCondominium;
      break;
    case "EL":
      component = EquipmentLimit;
      break;
  }

  if (component) {
    openPopup(component, {
      id: entity.id,
      geometry,
      entity,
      isProject,
      extra,
      folderIdMap: entity.folderId,
      right: true
    });
  }
};
